// extracted by mini-css-extract-plugin
export default {"customLabel":"CustomLabel_customLabel__wMjox","icon":"CustomLabel_icon__AtGmm"};